import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AddPopularLocationManagement from '../../../components/siteadmin/AddPopularLocation/AddPopularLocationManagement';

import s from './AddPopularLocation.css';

const PopularLocation = (props) => {

    const { data: { loading }, title } = props;

    return (
        <AddPopularLocationManagement
            title={title}
        />
    );
}

PopularLocation.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
    })
};

PopularLocation.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
)(PopularLocation);